import React from 'react';
import PropTypes from 'prop-types';
import Chip from '../Chip';
import { getFilterChips, formatDateFilterChip, getFilterUniqueKey } from './functions';
import DateFilter from './DateFilter';

const FilterChips = ({ disabled, filters, onRemoveFilter, style }) => {
  const chips = getFilterChips(filters);

  const getFilterDisplayValue = filter => {
    if (filter.type === DateFilter) {
      return formatDateFilterChip(filter);
    }

    const labelKey = filter.labelKey || 'label';
    return filter.getChipDisplay ? filter.getChipDisplay(filter.value) : filter.value[labelKey];
  }

  return (
    <div className="chips" style={style} data-component-type="filter-chips-row">
      {chips.map(filter => (
        <Chip
          key={getFilterUniqueKey(filter)}
          category={filter.label}
          data={filter.data}
          value={getFilterDisplayValue(filter)}
          onRemove={() => onRemoveFilter(filter)}
          disabled={disabled || filter.disabled}
        />
      ))}
    </div>
  );
}

FilterChips.propTypes = {
  disabled: PropTypes.bool,
  filters: PropTypes.arrayOf(PropTypes.shape({
    getChipCategoryDisplay: PropTypes.func,
    getChipDisplay: PropTypes.func,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired
  })).isRequired,
  onRemoveFilter: PropTypes.func.isRequired,
  style: PropTypes.object
};

export default FilterChips;
